import LegalLayout from './LegalLayout'

function PrivacyPolicy() {
    return (
        <LegalLayout title="Política de Privacidad y Protección de Datos Personales" subtitle="Factur 24/7">
            <section className="legal-section">
                <p>
                    Factur 24/7 es una aplicación de facturación electrónica comprometida con la protección de los datos
                    personales de sus usuarios, por lo que, en cumplimiento de la Ley Orgánica de Protección de Datos Personales
                    del Ecuador (LOPDP), Reglamento de la Ley Orgánica de Protección de Datos Personales del Ecuador (RLOPDP) y
                    demás normativa conexa en materia de protección de datos vigente en el Ecuador se establece la presente
                    política de privacidad y protección de datos. En la cual se establece los principios, procedimientos, medidas
                    técnicas y organizativas para garantizar el tratamiento legítimo, seguro y transparente de los datos
                    personales, conforme a los artículos 4, 7 y 10 de la LOPDP, además que a través de esta se informa la política,
                    prácticas, términos y condiciones de privacidad con respecto a los datos personales otorgados por los usuarios
                    por medio de la aplicación.
                </p>
                <p>
                    Es por ello que, es responsabilidad absoluta del usuario revisar atentamente esta política y, los términos y
                    condiciones, ya que le servirán para comprender las actividades, alcance del tratamiento de datos personales
                    que realiza factur 24/7, así como sus finalidades, a fin de que al momento de compartir su información personal
                    con nosotros este previamente informado de las condiciones en las que lo está haciendo. Estos términos y
                    condiciones se aplican sólo a la información recopilada a través de la aplicación factur 24/7.
                </p>
                <p>
                    La recopilación y tratamiento automatizado de los datos de carácter personal tiene como fines específicos las
                    actividades vinculadas a la emisión de facturas electrónicas, notas de crédito, gestión de clientes,
                    cumplimiento de obligaciones tributarias y otras actividades propias de factur 24/7. No se utilizarán para
                    fines incompatibles con estos propósitos.
                </p>
                <p>Estos datos únicamente serán compartidos a aquellas entidades que sean necesarias con el único objetivo de dar cumplimiento a la finalidad anteriormente expuesta.</p>
                <p>
                    Factur 24/7 podrá actualizar la presente Política de Privacidad en cualquier momento, respetando las
                    obligaciones y los derechos del ordenamiento jurídico vigente, por lo cual le pedimos que revise con
                    regularidad. Dicha actualización se hará pública en cualquier caso por parte de factur 24/7 y publicada en
                    <a href="https://factur247.com/politicas_de_privacidad" rel="noreferrer noopener">
                        https://factur247.com/politicas_de_privacidad
                    </a>
                    . Esta política tiene fecha de vigencia: 1 de junio de 2025.
                </p>
            </section>

            <section className="legal-section">
                <h2>1. Actividades efectuadas a través de factur 24/7</h2>
                <p>
                    De forma específica, la aplicación permite y/o permitirá las siguientes actividades: Emisión de comprobantes
                    electrónicos (facturas, notas de crédito, entre otros); validar, firmar y enviar dichos comprobantes
                    electrónicos; brindar acceso al historial de comprobantes generados durante la vigencia de la cuenta; cumplir
                    con obligaciones contractuales y de soporte técnico.
                </p>
                <p>
                    Factur 24/7 es una plataforma tecnológica que permite a personas naturales con RUC y empresas emitir
                    comprobantes electrónicos conforme a la normativa del SRI. No somos un Proveedor Autorizado de Comprobantes
                    Electrónicos (PAC), ni asumimos representación legal del usuario ante el Servicio de Rentas Internas.
                </p>
            </section>

            <section className="legal-section">
                <h2>2. Principios del Tratamiento de Datos</h2>
                <h3>2.1. Legalidad, Lealtad y Transparencia (Artículo 10(a) LOPDP)</h3>
                <p>
                    Los datos serán tratados de manera lícita, leal y transparente, informando a los titulares sobre las
                    finalidades del tratamiento mediante consentimiento previo, excepto en casos previstos por la ley.
                </p>
                <h3>2.2. Finalidad Determinada (Artículo 10(d) LOPDP)</h3>
                <p>
                    Los datos se recopilarán únicamente para fines específicos vinculados a la emisión de facturas electrónicas,
                    gestión de clientes y cumplimiento de obligaciones tributarias. No se utilizarán para fines incompatibles con
                    estos propósitos. No utilizamos sus datos para fines publicitarios ni los compartimos con terceros sin su
                    consentimiento expreso.
                </p>
                <h3>2.3. Minimización de Datos (Artículo 10(e) LOPDP)</h3>
                <p>Sólo se recolectarán datos estrictamente necesarios, como:</p>
                <ul>
                    <li>
                        <strong>Datos identificativos:</strong> Nombre, RUC/Cédula, dirección (Artículo 25 LOPDP).
                    </li>
                    <li>
                        <strong>Datos financieros:</strong> Los pagos se gestionan a través de terceros como Google Play Store, por lo que no se recolecta información bancaria directamente por la aplicación (Artículo 26 LOPDP).
                    </li>
                    <li>
                        <strong>Datos de contacto:</strong> Correo electrónico, teléfono (Artículo 4 LOPDP).
                    </li>
                </ul>
                <h3>2.4. Exactitud y Actualización (Artículo 10(f) LOPDP)</h3>
                <p>
                    Los usuarios podrán rectificar sus datos en cualquier momento a través de la aplicación o solicitándolo al
                    Delegado de Protección de Datos.
                </p>
                <h3>2.5. Conservación Limitada (Artículo 10(i) LOPDP)</h3>
                <p>
                    Los datos se conservarán durante el tiempo necesario para cumplir con las finalidades del tratamiento y los
                    plazos legales establecidos por la normativa vigente.
                </p>
                <p>
                    En particular, los datos vinculados a la emisión y gestión de comprobantes electrónicos (como facturas, notas
                    de crédito, retenciones, entre otros) serán conservados por un periodo mínimo de siete (7) años, conforme a lo
                    dispuesto por el Reglamento De Comprobantes De Venta, Retención y Documentos Complementarios emitidos mediante
                    decreto Ejecutivo No. 430, y en cumplimiento de lo establecidos en el Código Tributario del Ecuador.
                </p>
                <p>
                    Este periodo podrá ampliarse si existe una obligación legal adicional, un proceso administrativo o judicial
                    pendiente, o a efectos de auditoría o fiscalización por parte de las autoridades competentes.
                </p>
            </section>

            <section className="legal-section">
                <h2>3. Bases Legales del Tratamiento (Artículo 7 LOPDP)</h2>
                <p>El tratamiento se fundamenta en:</p>
                <ul>
                    <li>
                        <strong>Consentimiento explícito:</strong> Obtenido al registrarse en la aplicación.
                    </li>
                    <li>
                        <strong>Interés legítimo:</strong> Para prevenir fraudes y cumplir con obligaciones fiscales.
                    </li>
                    <li>
                        <strong>Cumplimiento de obligaciones legales:</strong> Como la emisión de comprobantes electrónicos exigidos por el SRI.
                    </li>
                </ul>
            </section>

            <section className="legal-section">
                <h2>4. Derechos de los Titulares (Artículos 12-20 LOPDP)</h2>
                <p>
                    Los usuarios, en su calidad de titulares de datos personales, tiene derecho a ejercer los siguientes derechos
                    reconocidos por la normativa ecuatoriana:
                </p>
                <ul>
                    <li>
                        <strong>Acceso:</strong> Consultar sus datos almacenados (Artículo 13).
                    </li>
                    <li>
                        <strong>Rectificación:</strong> Actualizar información inexacta (Artículo 14).
                    </li>
                    <li>
                        <strong>Eliminación:</strong> Solicitar la supresión de datos cuando ya no sean necesarios (Artículo 15). La eliminación se sujeta a las excepciones legales, como la conservación de datos por obligaciones tributarias (sección 2.5).
                    </li>
                    <li>
                        <strong>Oposición:</strong> Limitar el tratamiento para fines de marketing (Artículo 16).
                    </li>
                    <li>
                        <strong>Portabilidad:</strong> Recibir sus datos en formato estructurado (Artículo 17).
                    </li>
                </ul>
                <p>Para ejercer estos derechos, los usuarios podrán contactar al Delegado de Protección de Datos mediante:</p>
                <ul>
                    <li>
                        <strong>Correo electrónico:</strong>{' '}
                        <a href="mailto:protecciondatos@factur247.com">protecciondatos@factur247.com</a>
                    </li>
                    <li>
                        <strong>Formulario web:</strong>{' '}
                        <a href="https://factur247.com/derechos-arco/" rel="noreferrer noopener">
                            https://factur247.com/derechos-arco/
                        </a>
                    </li>
                </ul>
            </section>

            <section className="legal-section">
                <h2>5. Seguridad de los Datos (Artículo 37 LOPDP)</h2>
                <h3>5.1. Medidas Técnicas</h3>
                <ul>
                    <li>
                        <strong>Cifrado:</strong> Datos transmitidos vía TLS/SSL. Almacenamiento de datos en app mediante AES-256 y
                        en servidor passwords cifradas mediante hash o RSA.
                    </li>
                    <li>
                        <strong>Control de acceso:</strong> Autenticación multifactor (MFA) para empleados.
                    </li>
                    <li>
                        <strong>Protección contra malware:</strong> Uso de firewalls y antivirus.
                    </li>
                </ul>
                <h3>5.2. Medidas Organizativas</h3>
                <ul>
                    <li>
                        <strong>Capacitación anual:</strong> en protección de datos para el personal (Artículo 39 LOPDP).
                    </li>
                </ul>
                <h3>5.3. Notificación de Breaches</h3>
                <p>
                    En caso de vulneraciones de seguridad que afecten derechos de los titulares, se notificará a la
                    Superintendencia de Protección de Datos Personales en un plazo máximo de 72 horas (Artículo 40 LOPDP).
                </p>
            </section>

            <section className="legal-section">
                <h2>6. Permisos requeridos por la aplicación</h2>
                <p>
                    Factur 24/7 podrá solicitar determinados permisos para funcionar correctamente, los cuales son estrictamente
                    necesarios para cumplir con sus fines legales y funcionales:
                </p>
                <ul>
                    <li>
                        <strong>Acceso a almacenamiento del dispositivo:</strong> Para permitir la descarga y almacenamiento de
                        datos del usuario, comprobantes electrónicos firmados y otros documentos tributarios.
                    </li>
                    <li>
                        <strong>Acceso a Internet:</strong> Necesario para validar, firmar electrónicamente y enviar los comprobantes al SRI.
                    </li>
                    <li>
                        <strong>Carga de archivos de firma electrónica:</strong> La aplicación permite que el usuario cargue su archivo de firma electrónica para firmar comprobantes electrónicos. Este archivo se almacena en el servidor de manera segura con el password encriptado, y se utiliza exclusivamente para cumplir con las obligaciones tributarias del usuario.
                    </li>
                    <li>
                        <strong>Cámara:</strong> Para toma de fotos de los productos que el usuario factura o de su logotipo.
                    </li>
                </ul>
                <p>
                    Factur 24/7 no accede a contactos, ubicación, micrófono, SMS ni otros permisos innecesarios. Todos los accesos
                    están limitados a los fines descritos y siempre bajo el principio de minimización de datos.
                </p>
            </section>

            <section className="legal-section">
                <h2>7. Transferencias Internacionales (Artículo 55 LOPDP)</h2>
                <p>
                    Los datos podrán ser almacenados en servidores ubicados fuera del Ecuador, en proveedores que implementan
                    medidas de seguridad y privacidad alineadas con estándares internacionales, conforme a lo dispuesto en el Art.
                    55 de la LOPDP.
                </p>
            </section>

            <section className="legal-section">
                <h2>8. Delegado de Protección de Datos</h2>
                <p>El responsable de supervisar el cumplimiento de esta política es:</p>
                <ul>
                    <li>
                        <strong>Nombre:</strong> Andrés Dario Riofrío Valdivieso
                    </li>
                    <li>
                        <strong>Contacto:</strong>{' '}
                        <a href="mailto:dpo@factur247.com">dpo@factur247.com</a>
                    </li>
                </ul>
            </section>

            <section className="legal-section">
                <h2>9. Actualizaciones de la Política</h2>
                <p>
                    Esta política se revisará anualmente o cuando cambien las regulaciones aplicables. Las modificaciones se
                    comunicarán a los usuarios mediante notificación en la aplicación o correo electrónico.
                </p>
            </section>

            <section className="legal-section">
                <h2>10. Legislación aplicable y resolución de conflictos</h2>
                <p>
                    Esta Política de Privacidad y Protección de Datos, así como cualquier disputa o conflicto derivado del uso de
                    la aplicación factur 24/7, se regirá por la legislación vigente en la República del Ecuador, en especial la Ley
                    Orgánica de Protección de Datos Personales, Ley de Comercio Electrónico, Firmas Electrónicas y Mensajes de
                    Datos, Código Orgánico de la Economía Social de los Conocimientos, Creatividad e Innovación, y Ley de
                    Arbitraje y Mediación.
                </p>
                <p>
                    En caso de presentarse cualquier controversia, conflicto o reclamación entre el usuario y factur 24/7,
                    relacionada con el tratamiento de datos personales, uso de la aplicación o cualquier obligación derivada de
                    esta política, las partes se comprometen a resolver el conflicto conforme al siguiente procedimiento:
                </p>
                <h3>10.1. Etapa de mediación</h3>
                <p>
                    Las partes intentarán resolver sus diferencias de forma amistosa a través de un proceso de mediación
                    administrado por el Centro de Arbitraje y Mediación de la Cámara de Comercio de Loja, conforme a su reglamento
                    y la Ley de Arbitraje y Mediación. La mediación será confidencial y voluntaria.
                </p>
                <h3>10.2. Etapa de arbitraje</h3>
                <p>
                    Si no se alcanza un acuerdo en la etapa de mediación dentro del plazo de 30 días calendario desde su inicio, o
                    si alguna de las partes se niega a participar, la controversia será sometida a arbitraje en derecho, también
                    administrado por el mismo Centro.
                </p>
                <p>El arbitraje se sujetará a las siguientes condiciones:</p>
                <ul>
                    <li>
                        <strong>Será resuelto:</strong> por un árbitro único, designado por el Centro.
                    </li>
                    <li>
                        <strong>El procedimiento:</strong> será confidencial.
                    </li>
                    <li>
                        <strong>El tribunal arbitral:</strong> podrá solicitar la cooperación de autoridades judiciales, administrativas o policiales para ejecutar medidas cautelares, sin necesidad de acudir a un juez ordinario.
                    </li>
                    <li>
                        <strong>Cualquier reconvención:</strong> o demanda cruzada también será sometida a este mecanismo.
                    </li>
                </ul>
            </section>

            <section className="legal-section">
                <p>
                    <strong>Fecha de entrada en vigor:</strong> 1 de junio de 2025.
                </p>
            </section>
        </LegalLayout>
    )
}

export default PrivacyPolicy
